import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Loader } from '@grandvisionhq/common';
import TimeSlotsItem from './TimeSlotsItem/TimeSlotsItemContainer.js';
import { isEqualTimeSlot } from './utils.js';

const TimeSlots = (_param)=> {
    var { className , loading , slots , selected , timeFormatter , onSelectTime  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "loading",
        "slots",
        "selected",
        "timeFormatter",
        "onSelectTime"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('timeslots', className)
    }), loading ? /*#__PURE__*/ React.createElement("div", {
        className: "timeslots__loader"
    }, /*#__PURE__*/ React.createElement(Loader, null)) : slots.map((slot)=>/*#__PURE__*/ React.createElement(TimeSlotsItem, {
            key: slot.from.toUTCString(),
            selected: isEqualTimeSlot(slot, selected),
            label: timeFormatter(slot.from),
            slot: slot,
            onSelect: onSelectTime
        })
    ));
};
var TimeSlots$1 = TimeSlots;

export { TimeSlots$1 as default };
//# sourceMappingURL=TimeSlots.js.map
